import { IndustryType } from "./types";

export const INDUSTRY_TYPES: Record<string, IndustryType> = {
  INDUSTRY: "INDUSTRY",
  SIC: "SIC",
  NAICS: "NAICS",
};

export const INDUSTRY_MESSAGES = {
  PLACEHOLDER: "Search industries...",
  NO_RESULTS: "No industries found",
};

export const TOGGLE_BUTTON_OPTIONS = [
  INDUSTRY_TYPES.INDUSTRY,
  INDUSTRY_TYPES.SIC,
  INDUSTRY_TYPES.NAICS,
];

export const NAICS_HELP_URL =
  "https://www.census.gov/naics/?58967?yearbck=2012";
